import { DeleteSupplierAccountComponent } from './../../components/delete-supplier-account/delete-supplier-account.component';
import { AddSupplierAccountRequestComponent } from './../../components/add-supplier-account-request/add-supplier-account-request.component';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, Validators } from '@angular/forms';
import { AddAccountPayComponent } from './../../components/add-account-pay/add-account-pay.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { GetSupplierAccountsService } from '../../services/get-supplier-accounts.service';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GetSupplierAccountRequestsService } from '../../services/get-supplier-account-requests.service';

@Component({
  selector: 'app-account-pay',
  templateUrl: './account-pay.component.html',
  styleUrls: ['./account-pay.component.scss']
})
export class AccountPayComponent implements OnInit {
/* --------------------------------- Fields --------------------------------- */
  filterForm = this.fb.group({
    limit: [50, [Validators.required]],
    offset: [0, [Validators.required]]
  })
  filterForm1 = this.fb.group({
    limit: [50, [Validators.required]],
    offset: [0, [Validators.required]]
  })
  filterSubject = new BehaviorSubject<any>(this.filterForm);
  filterSubject1 = new BehaviorSubject<any>(this.filterForm1);
  displayedColumns: string[] = ['sNo', 'supplier_name', 'account_number','action'];
  displayedColumns1: string[] = ['sNo', 'supplier_name', 'name', 'email', 'phone'];

  dataSource : MatTableDataSource<any>;
  dataSource1 : MatTableDataSource<any>;
  totalElements = 0;
  totalElements1 = 0;

  constructor(
    private _dialog: MatDialog,
    private fb: FormBuilder,
    private getSupplierAccountsService: GetSupplierAccountsService,
    private getSupplierAccountRequestsService: GetSupplierAccountRequestsService
  ) { }

  ngOnInit(): void {
    this.filterSubject.pipe(switchMap(filterData=>{
      return this.getSupplierAccountsService.getSupplierAccounts(filterData)
    })).subscribe(([supplier_accounts, totalElements]: [any, number])=>{
      console.log(totalElements);
      this.dataSource = new MatTableDataSource<any>(supplier_accounts);
      this.totalElements = totalElements;
    });
    this.filterSubject1.pipe(switchMap(filterData=>{
      return this.getSupplierAccountRequestsService.getSupplierAccountRequests(filterData)
    })).subscribe(([supplier_account_requests, totalElements1]: [any, number])=>{
      console.log(totalElements1);
      this.dataSource1 = new MatTableDataSource<any>(supplier_account_requests);
      this.totalElements1 = totalElements1;
    });
  }
  addAccountPay() {
   const dialogRef = this._dialog.open(AddAccountPayComponent, {
      width: '40%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  sendAccountRequestDialog() {
   const dialogRef = this._dialog.open(AddSupplierAccountRequestComponent, {
      width: '40%',
      panelClass: 'custom-modal'
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.filterSubject1.next(this.filterForm1.value);
      }
    })
  }
  deleteDialog(accountPay: any) {
   const dialogRef = this._dialog.open(DeleteSupplierAccountComponent, {
      width: '35%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      data: accountPay
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.filterSubject.next(this.filterForm1.value);
      }
    })
  }

  get limit(){
    return this.filterForm.get('limit');
  }
  get offset(){
    return this.filterForm.get('offset');
  }
  get limit1(){
    return this.filterForm1.get('limit');
  }
  get offset1(){
    return this.filterForm1.get('offset');
  }
  changePage(ev: PageEvent){
    this.offset.setValue(ev.pageIndex * ev.pageSize);
    this.filterSubject.next(this.filterForm.value);
  }

  changePage1(ev: PageEvent){
    this.offset1.setValue(ev.pageIndex * ev.pageSize);
    this.filterSubject1.next(this.filterForm1.value);
  }
}
